// Wundly: subtle fade-up-on-scroll for content sections, mirroring heyfriendli.com's
// restrained scroll motion. Progressive enhancement only — CSS never hides content
// unless this script actually runs and adds the reveal class.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll('main#MainContent .shopify-section');
  if (!targets.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wundly-in-view');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach(function (el) {
    el.classList.add('wundly-reveal');
    io.observe(el);
  });
})();
